var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBooking
    ? _c("div", [
        _c("div", { staticClass: "dashboard-page-title" }, [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _vm.booking && _vm.booking.campaign
                ? _c("booking-campaign-banner", {
                    attrs: { campaign: _vm.booking.campaign },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "h1",
                    [
                      _vm._v("\n            Overview\n            "),
                      !_vm.$vlastMode
                        ? _c("help-link", {
                            attrs: {
                              anchor:
                                _vm.$route.name === "bookings.show.payment"
                                  ? "payment"
                                  : "bookings",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [_c("booking-status", { attrs: { booking: _vm.booking } })],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _vm.$vlastMode && _vm.$userIsAdmin && _vm.booking.is_offer
              ? [
                  _c("offer-booking-responses-list", {
                    attrs: { booking: _vm.booking },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsClient || _vm.$userIsAdmin
              ? _c("booking-progress", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            (_vm.$paymentsModuleEnabled || _vm.$invoicesEnabledForUser) &&
            (_vm.$userIsAdmin || _vm.$userIsClient)
              ? _c(
                  "ul",
                  { staticClass: "nav nav-pills nav-page" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: { name: "bookings.show", params: { id: _vm.id } },
                          tag: "li",
                          exact: "",
                        },
                      },
                      [_c("a", [_vm._v("Overview")])]
                    ),
                    _vm._v(" "),
                    _vm.booking.payments &&
                    _vm.booking.payments.length &&
                    _vm.$paymentsModuleEnabled
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              "active-class": "active",
                              to: {
                                name: "bookings.show.payment",
                                params: { id: _vm.id },
                              },
                              tag: "li",
                              exact: "",
                            },
                          },
                          [_c("a", [_vm._v("Payment")])]
                        )
                      : _vm.$invoicesEnabledForUser
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              "active-class": "active",
                              to: {
                                name: "bookings.show.payment",
                                params: { id: _vm.id },
                              },
                              tag: "li",
                              exact: "",
                            },
                          },
                          [_c("a", [_vm._v("Invoice")])]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : (_vm.$userIsTalent || _vm.$userIsManager) &&
                _vm.$invoicesEnabledForUser
              ? _c(
                  "ul",
                  { staticClass: "nav nav-pills nav-page" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: { name: "bookings.show", params: { id: _vm.id } },
                          tag: "li",
                          exact: "",
                        },
                      },
                      [_c("a", [_vm._v("Overview")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: {
                            name: "bookings.show.invoice",
                            params: { id: _vm.id },
                          },
                          tag: "li",
                          exact: "",
                        },
                      },
                      [_c("a", [_vm._v("Invoice")])]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("router-view"),
            _vm._v(" "),
            (_vm.$userIsAdmin || _vm.$userIsClient) &&
            _vm.bookingTermsAreNotAccepted
              ? _c("booking-terms-and-conditions-modal", {
                  attrs: {
                    booking: _vm.booking,
                    talents: _vm.bookingAttendingTalent,
                    "property-mutator": _vm.setBookingProperty,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            (_vm.$userIsAdmin || _vm.$userIsClient) &&
            _vm.bookingTermsAreAccepted
              ? _c("booking-terms-and-conditions-modal-no-action", {
                  attrs: {
                    booking: _vm.booking,
                    talents: _vm.bookingAttendingTalent,
                  },
                })
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }